// src/components/ui/Badge/Badge.jsx
// 从80+行简化到30行，专注洪水严重程度

import React from 'react';
import styles from './Badge.module.css';

const Badge = ({
  children,
  variant = 'default',  // default, flood-mild, flood-moderate, flood-severe
  size = 'md',         // sm, md, lg
  icon,               // 可选图标
  pulse = false,      // 脉冲动画（严重级别用）
  className
}) => {
  // 构建CSS类名
  const badgeClasses = [
    styles.badge,
    styles[variant],
    styles[size],
    pulse && styles.pulse,
    className
  ].filter(Boolean).join(' ');

  return (
    <span className={badgeClasses}>
      {/* 图标 */}
      {icon && (
        <span className={styles.icon}>{icon}</span>
      )}
      
      {/* 内容 */}
      {children}
    </span>
  );
};

export default Badge;